(function () {
    'use strict';

    angular
        .module('app')
        .controller('FileEditCtrl', FileEditCtrl);

    FileEditCtrl.$inject = [
        '$routeParams',
        '$scope',
        '$q',
        '$location',
        'DmsService',
        'WindowTitleService',
        'DialogService',
        'TagsService',
        'UnsavedChangesService',
        'NavigationAidService',
        'LastUpdatedService',
        'UrlService',
        'ItemService'];

    /**
     * Controller for file add/edit page.
     */
    function FileEditCtrl(
        $routeParams,
        $scope,
        $q,
        $location,
        DmsService,
        WindowTitleService,
        DialogService,
        TagsService,
        UnsavedChangesService,
        NavigationAidService,
        LastUpdatedService,
        UrlService,
        ItemService) {

        /* jshint validthis:true */
        var vm = this;
        vm.viewTitle = 'Add Files';
        vm.fileSelectorLabel = 'Drag & drop files here...';
        vm.fileMetaData = null;
        vm.tags = [];
        vm.loading = true;
        vm.notFound = false;
        vm.errorLoading = false;
        vm.saveInProgress = false;
        vm.close = close;
        vm.saveFile = saveFile;
        vm.deleteFile = deleteFile;
        vm.copyFile = copyFile;
        vm.fileUploadApi = {};
        vm.downloadFile = downloadFile;
        vm.fileDownloadName = 'Download File';
        Object.defineProperty(vm, 'lastUpdatedLabel', { get: function () { return LastUpdatedService.getLabel(vm.fileMetaData); } });
        Object.defineProperty(vm, 'fileIsNew', {
            get: function () { return !($routeParams.id && $routeParams.id !== 'new'); }
        });
        Object.defineProperty(vm, 'dirty', {
            get: function () { return UnsavedChangesService.dirty; }
        });
        Object.defineProperty(vm, 'dirtyCheckModel', {
            get: function () { return { metaData: vm.fileMetaData, fileCount: _.isNil(vm.fileBinary) ? 0 : vm.fileBinary.length }; }
        });
        Object.defineProperty(vm, 'showFilenameTextbox', {
            get: function () { return !(vm.fileBinary && vm.fileBinary.length > 1); }
        });

        activate();

        function activate() {
            updateViewTitle();

            loadFile();
            loadTags();

            $scope.$watch('vm.fileBinary[0].lfFile.name', function (newFileName) {
                // When file is selected, auto-fill the file name property
                if (!_.isNil(newFileName) && newFileName !== '') {
                    var fileNameParts = newFileName.split('.');
                    if (fileNameParts.length > 1) {
                        var fileExtension = fileNameParts.pop();
                        vm.fileMetaData.FileNameWithoutExtension = newFileName.substr(0, newFileName.length - fileExtension.length - 1);
                    } else {
                        vm.fileMetaData.FileNameWithoutExtension = newFileName;
                    }
                } else if (!_.isNil(vm.fileMetaData) && vm.fileIsNew) {
                    vm.fileMetaData.FileNameWithoutExtension = newFileName;
                }
            });
        }

        /**
         * Update Title to be shown at the top of the view and browser window/tab title.
         */
        function updateViewTitle() {
            var title = '';
            var fileSelectorLabel = 'Drag & drop file here...';

            if (vm.fileIsNew) {
                title = 'Add Files';
                fileSelectorLabel = 'Drag & drop files here...';
            } else {
                title = 'File';

                if (!_.isNil(vm.fileMetaData) && !_.isNil(vm.fileMetaData.FileNameWithoutExtension)) {
                    title += ' - ' + vm.fileMetaData.FileNameWithoutExtension;

                    if (!_.isNil(vm.fileMetaData.FileExtension)) {
                        title += '.' + vm.fileMetaData.FileExtension;
                    }
                }
            }

            // Truncate so the title isn't hugely long
            title = title.substr(0, 128);

            vm.viewTitle = title;
            WindowTitleService.setTitle(title);
            vm.fileSelectorLabel = fileSelectorLabel;
        }

        /**
         * Load the file.
         */
        function loadFile() {
            var getFileMetaDataPromise;

            if (vm.fileIsNew && $routeParams.copyFileId) {
                // New File, copying an existing file.

                var copyFileId = Number($routeParams.copyFileId);
                if (!_.isNumber(copyFileId)) {
                    copyFileId = null;
                }

                getFileMetaDataPromise = DmsService.getFileMetaData(copyFileId)
                    .then(function (fileToCopy) {
                        // Reset properties that aren't to be copied.
                        delete fileToCopy.Id;
                        delete fileToCopy.UpdatedBy;
                        delete fileToCopy.UpdatedByUserName;
                        delete fileToCopy.UpdatedDate;
                        delete fileToCopy.CreatedBy;
                        delete fileToCopy.CreatedDate;
                        fileToCopy.CopyFromFileId = copyFileId;
                        return fileToCopy;
                    });

            } else if (vm.fileIsNew) {
                // New File.

                // Convert route parameter to a number, because otherwise it's a string
                var relatedItemId = Number($routeParams.relatedItemId);
                if (!_.isNumber(relatedItemId)) {
                    relatedItemId = null;
                }

                getFileMetaDataPromise = $q.when({
                    FileNameWithoutExtension: '',
                    FileExtension: '',
                    FileDescription: '',
                    UpdatedDate: new Date(),
                    Tags: [],
                    RelatedItem: relatedItemId
                });

            } else {
                // An existing File.
                getFileMetaDataPromise = DmsService.getFileMetaData($routeParams.id);
            }


            getFileMetaDataPromise
                .then(getFileMetaDataOk, getFileMetaDataError)
                .finally(function () { vm.loading = false; });

            function getFileMetaDataOk(fileMetaData) {
                vm.fileMetaData = fileMetaData;

                if (fileMetaData.FileNameWithoutExtension.length > 0) {
                    vm.fileDownloadName = fileMetaData.FileNameWithoutExtension + '.' + fileMetaData.FileExtension;
                }

                UnsavedChangesService.register({
                    scope: $scope,
                    modelExpression: 'vm.dirtyCheckModel',
                    saveFunction: saveFile,
                    unsavedItemName: 'File'
                });

                if (vm.fileIsNew && $routeParams.copyFileId) {
                    UnsavedChangesService.dirty = true;
                }

                updateViewTitle();
            }

            function getFileMetaDataError(response) {
                if (response.status === 404) {
                    vm.notFound = true;
                } else {
                    vm.errorLoading = true;
                    DialogService.error('Error fetching File', response);
                }
            }
        }

        /**
         * Load tags into the vm.tags variable.
         *
         * @returns {promise} A promise that resolves once the tags are loaded, or an error occurred.
         */
        function loadTags() {
            return TagsService.query({ tagUsage: 'File' })
                .then(getTagsOk, getTagsError);

            function getTagsOk(data) {
                vm.tags = data.Tags;
            }

            function getTagsError(response) {
                DialogService.error('Error fetching Tags', response);
            }
        }

        /**
         * Save file to the server.
         *
         * @return {promise}
         */
        function saveFile() {
            if (!_.isNil(vm.editFileForm) && vm.editFileForm.$invalid) {
                DialogService.messageList('Error saving File', null, vm.editFileForm.$error);
                return $q.reject();
            }

            var fileBinary;
            if (vm.fileBinary.length > 0) {
                if (vm.fileBinary.length === 1) {
                    fileBinary = vm.fileBinary[0].lfFile;
                } else {
                    fileBinary = [];
                    
                    for (var i = 0; i < vm.fileBinary.length; i++) {
                        fileBinary.push(vm.fileBinary[i].lfFile);
                    }
                }

                var fileNameParts = vm.fileBinary[0].lfFile.name.split('.');
                if (fileNameParts.length > 1) {
                    vm.fileMetaData.FileExtension = fileNameParts.pop();
                } else {
                    vm.fileMetaData.FileExtension = '';
                }
            }

            vm.saveInProgress = true;

            return DmsService.saveFile(vm.fileMetaData, fileBinary)
                .then(saveFileOk, saveFileError);

            function saveFileOk(savedFileMetaData) {
                // Clear any uploaded files
                vm.fileUploadApi.removeAll();

                if (vm.fileIsNew) {
                    UnsavedChangesService.dirty = false;
                    NavigationAidService.goBack();
                } else {
                    vm.fileMetaData = savedFileMetaData;

                    if (savedFileMetaData.FileNameWithoutExtension.length > 0) {
                        vm.fileDownloadName = savedFileMetaData.FileNameWithoutExtension + '.' + savedFileMetaData.FileExtension;
                    }

                    UnsavedChangesService.register({
                        scope: $scope,
                        modelExpression: 'vm.dirtyCheckModel',
                        saveFunction: saveFile,
                        unsavedItemName: 'File'
                    });

                    updateViewTitle();
                }

                vm.saveInProgress = false;
            }

            function saveFileError(response) {
                vm.saveInProgress = false;

                DialogService.error('Error saving File', response);
                return $q.reject(response);
            }
        }

        function deleteFile() {
            return DialogService.confirm('Delete the File?', 'Delete File confirm')
                .then(deleteConfirmed);

            function deleteConfirmed() {
                ItemService.deleteItems([$routeParams.id])
                    .then(deleteOk, deleteError);
            }

            function deleteOk() {
                UnsavedChangesService.dirty = false;
                NavigationAidService.goBack();
            }

            function deleteError(response) {
                DialogService.error('Error deleting File', response);
            }
        }

        /**
         * Navigate to an "Add File" page with the current file loaded as a copy.
         */
        function copyFile() {
            if (UnsavedChangesService.dirty) {
                DialogService.unsavedChanges('File')
                    .then(function () {
                        saveFile().then(goToCopyView);
                    });
            } else {
                goToCopyView();
            }

            function goToCopyView() {
                $location.url('files/new?copyFileId=' + vm.fileMetaData.Id);
            }
        }

        function downloadFile() {
            DmsService.retrieveFile($routeParams.id, true)
                .catch(downloadFileError);

            function downloadFileError(response) {
                DialogService.error('Error downloading File', response);
            }
        }

        /**
         * Close the edit view / go back to previous view.
         */
        function close() {
            NavigationAidService.goBack();
        }
    }
})();